<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <tables-page
      :tableData="data.table_data"
      :tableFields="data.table_fields"
    >
      <template #cell(A_status_0)="row">
        <span
          :class="{'link': row.item.A_status_0.isOpenContractModal}"
          @click="row.item.A_status_0.isOpenContractModal ? openContractModal(row.item.A_status_0) : null"
        >
          {{ row.item.A_status_0.value }}
        </span>
      </template>

      <template #cell(A_status_1)="row">
        <span
          :class="{'link': row.item.A_status_1.isOpenContractModal}"
          @click="row.item.A_status_1.isOpenContractModal ? openContractModal(row.item.A_status_1) : null"
        >
          {{ row.item.A_status_1.value }}
        </span>
      </template>

      <template #cell(A_status_2)="row">
        <span
          :class="{'link': row.item.A_status_2.isOpenContractModal}"
          @click="row.item.A_status_2.isOpenContractModal ? openContractModal(row.item.A_status_2) : null"
        >
          {{ row.item.A_status_2.value }}
        </span>
      </template>

      <template #cell(A_status_3)="row">
        <span
          :class="{'link': row.item.A_status_3.isOpenContractModal}"
          @click="row.item.A_status_3.isOpenContractModal ? openContractModal(row.item.A_status_3) : null"
        >
          {{ row.item.A_status_3.value }}
        </span>
      </template>

      <template #cell(A_status_4)="row">
        <span
          :class="{'link': row.item.A_status_4.isOpenContractModal}"
          @click="row.item.A_status_4.isOpenContractModal ? openContractModal(row.item.A_status_4) : null"
        >
          {{ row.item.A_status_4.value }}
        </span>
      </template>

       <template #cell(B_status_0)="row">
        <span
          :class="{'link': row.item.B_status_0.isOpenContractModal}"
          @click="row.item.B_status_0.isOpenContractModal ? openContractModal(row.item.B_status_0) : null"
        >
          {{ row.item.B_status_0.value }}
        </span>
      </template>

       <template #cell(B_status_1)="row">
        <span
          :class="{'link': row.item.B_status_1.isOpenContractModal}"
          @click="row.item.B_status_1.isOpenContractModal ? openContractModal(row.item.B_status_1) : null"
        >
          {{ row.item.B_status_1.value }}
        </span>
      </template>

       <template #cell(B_status_2)="row">
        <span
          :class="{'link': row.item.B_status_2.isOpenContractModal}"
          @click="row.item.B_status_2.isOpenContractModal ? openContractModal(row.item.B_status_2) : null"
        >
          {{ row.item.B_status_2.value }}
        </span>
      </template>

       <template #cell(B_status_3)="row">
        <span
          :class="{'link': row.item.B_status_3.isOpenContractModal}"
          @click="row.item.B_status_3.isOpenContractModal ? openContractModal(row.item.B_status_3) : null"
        >
          {{ row.item.B_status_3.value }}
        </span>
      </template>

       <template #cell(B_status_4)="row">
        <span
          :class="{'link': row.item.B_status_4.isOpenContractModal}"
          @click="row.item.B_status_4.isOpenContractModal ? openContractModal(row.item.B_status_4) : null"
        >
          {{ row.item.B_status_4.value }}
        </span>
      </template>

      <template #cell(C_status_0)="row">
        <span
          :class="{'link': row.item.C_status_0.isOpenContractModal}"
          @click="row.item.C_status_0.isOpenContractModal ? openContractModal(row.item.C_status_0) : null"
        >
          {{ row.item.C_status_0.value }}
        </span>
      </template>

      <template #cell(C_status_1)="row">
        <span
          :class="{'link': row.item.C_status_1.isOpenContractModal}"
          @click="row.item.C_status_1.isOpenContractModal ? openContractModal(row.item.C_status_1) : null"
        >
          {{ row.item.C_status_1.value }}
        </span>
      </template>

      <template #cell(C_status_2)="row">
        <span
          :class="{'link': row.item.C_status_2.isOpenContractModal}"
          @click="row.item.C_status_2.isOpenContractModal ? openContractModal(row.item.C_status_2) : null"
        >
          {{ row.item.C_status_2.value }}
        </span>
      </template>

      <template #cell(C_status_3)="row">
        <span
          :class="{'link': row.item.C_status_3.isOpenContractModal}"
          @click="row.item.C_status_3.isOpenContractModal ? openContractModal(row.item.C_status_3) : null"
        >
          {{ row.item.C_status_3.value }}
        </span>
      </template>

      <template #cell(C_status_4)="row">
        <span
          :class="{'link': row.item.C_status_4.isOpenContractModal}"
          @click="row.item.C_status_4.isOpenContractModal ? openContractModal(row.item.C_status_4) : null"
        >
          {{ row.item.C_status_4.value }}
        </span>
      </template>
    </tables-page>

    <!-- 契約 modal -->
    <member-age-distribution-contract-modal
      v-model="status.contractModal"
      :data="data.temp_table_data" />
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import reportApi from "@/models/API/reportApi";
import TablesPage from "@/components/layouts/TablesPage";
import MemberAgeDistributionContractModal from"./components/modal/MemberAgeDistributionContractModal";

export default {
  name: 'memberAgeDistribution',
  components: {
    BreadCrumb,
    TablesPage,
    MemberAgeDistributionContractModal
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '報表', url: '', isActive: true },
          { name: '互助人年齡層分布', url: '', isActive: false }
        ]
      },
      status: {
        contractModal: false
      },
      options: {
        year: [],
      },
      data: {
        table_data: [],
        table_fields: [
          {
            key: "age",
            label: "年齡層",
          },
          {
            key: "A_status_0",
            label: "A組有效",
            plan: 'A',
            status: 0
          },
          {
            key: "A_status_1",
            label: "A組身故",
            plan: 'A',
            status: 1
          },
          {
            key: "A_status_2",
            label: "A組停效",
            plan: 'A',
            status: 2
          },
          {
            key: "A_status_3",
            label: "A組除會",
            plan: 'A',
            status: 3
          },
          {
            key: "A_status_4",
            label: "A組墊繳",
            plan: 'A',
            status: 4
          },
           {
            key: "B_status_0",
            label: "B組有效",
            plan: 'B',
            status: 0
          },
          {
            key: "B_status_1",
            label: "B組身故",
            plan: 'B',
            status: 1
          },
          {
            key: "B_status_2",
            label: "B組停效",
            plan: 'B',
            status: 2
          },
          {
            key: "B_status_3",
            label: "B組除會",
            plan: 'B',
            status: 3
          },
          {
            key: "B_status_4",
            label: "B組墊繳",
            plan: 'B',
            status: 4
          },
          {
            key: "C_status_0",
            label: "C組有效",
            plan: 'C',
            status: 0
          },
          {
            key: "C_status_1",
            label: "C組身故",
            plan: 'C',
            status: 1
          },
          {
            key: "C_status_2",
            label: "C組停效",
            plan: 'C',
            status: 2
          },
          {
            key: "C_status_3",
            label: "C組除會",
            plan: 'C',
            status: 3
          },
          {
            key: "C_status_4",
            label: "C組墊繳",
            plan: 'C',
            status: 4
          },
          {
            key: "status_0_percentage",
            label: "有效佔比"
          },
          {
            key: "status_1_percentage",
            label: "身故佔比",
          },
          {
            key: "status_2_percentage",
            label: "停效佔比",
          },
          {
            key: "status_3_percentage",
            label: "除會佔比",
          },
          {
            key: "status_4_percentage",
            label: "墊繳佔比",
          },
          {
            key: "total_number",
            label: "總筆數",
          },
          {
            key: "all_percentage",
            label: "%",
          },
        ],
        temp_table_data: {}
      },
    }
  },
  computed: {

  },
  mounted() {
    this.reportApi = new reportApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.getReportMemberAge();
    },
    // 取得互助人年齡層
    getReportMemberAge() {
      this.reportApi.getReportMemberAge((response) => {
        const res = response.data;

        this.tableFormatHandler(res.data[0])
      })
    },
    // 表格格式整理
    tableFormatHandler(data) {
      const table_classified_data = {
        age_20_29: { age: '20 - 29歲', age_start: 20, age_end: 29, total_number: 0 },
        age_30_39: { age: '30 - 39歲', age_start: 30, age_end: 39, total_number: 0 },
        age_40_49: { age: '40 - 49歲', age_start: 40, age_end: 49, total_number: 0 },
        age_50_59: { age: '50 - 59歲', age_start: 50, age_end: 59, total_number: 0 },
        age_60_69: { age: '60 - 69歲', age_start: 60, age_end: 69, total_number: 0 },
        age_70_79: { age: '70 - 79歲', age_start: 70, age_end: 79, total_number: 0 },
        age_80_89: { age: '80 - 89歲', age_start: 80, age_end: 89, total_number: 0 },
        age_90_99: { age: '90 - 99歲', age_start: 90, age_end: 99, total_number: 0 },
        age_100: { age: '100歲以上', age_start: 100, age_end: null, total_number: 0 },
        age_total: { age: '總計', total_number: 0 }
      };

      // const status_suffix = ['A_status_0', 'A_status_1', 'A_status_2', 'A_status_3', 'A_status_4', 'B_status_0', 'B_status_1', 'B_status_2', 'B_status_3', 'B_status_4', 'status_0_percentage', 'status_1_percentage', 'status_2_percentage', 'status_3_percentage', 'status_4_percentage', 'all_percentage'];

      Object.entries(table_classified_data).forEach(([table_key, table_value]) => {
        this.data.table_fields.forEach(item => {
          const current_key = `${table_key}_${item.key}`;

          const current_A_status_0_value = data[`${table_key}_A_status_0`];
          const current_B_status_0_value = data[`${table_key}_B_status_0`];
          const current_C_status_0_value = data[`${table_key}_C_status_0`];
          const current_total_A_status_0_value = data['age_total_A_status_0'];
          const current_total_B_status_0_value = data['age_total_B_status_0'];
          const current_total_C_status_0_value = data['age_total_C_status_0'];

          const current_A_status_1_value = data[`${table_key}_A_status_1`];
          const current_B_status_1_value = data[`${table_key}_B_status_1`];
          const current_C_status_1_value = data[`${table_key}_C_status_1`];
          const current_total_A_status_1_value = data['age_total_A_status_1'];
          const current_total_B_status_1_value = data['age_total_B_status_1'];
          const current_total_C_status_1_value = data['age_total_C_status_1'];

          const current_A_status_2_value = data[`${table_key}_A_status_2`];
          const current_B_status_2_value = data[`${table_key}_B_status_2`];
          const current_C_status_2_value = data[`${table_key}_C_status_2`];
          const current_total_A_status_2_value = data['age_total_A_status_2'];
          const current_total_B_status_2_value = data['age_total_B_status_2'];
          const current_total_C_status_2_value = data['age_total_C_status_2'];

          const current_A_status_3_value = data[`${table_key}_A_status_3`];
          const current_B_status_3_value = data[`${table_key}_B_status_3`];
          const current_C_status_3_value = data[`${table_key}_C_status_3`];
          const current_total_A_status_3_value = data['age_total_A_status_3'];
          const current_total_B_status_3_value = data['age_total_B_status_3'];
          const current_total_C_status_3_value = data['age_total_C_status_3'];

          const current_A_status_4_value = data[`${table_key}_A_status_4`];
          const current_B_status_4_value = data[`${table_key}_B_status_4`];
          const current_C_status_4_value = data[`${table_key}_C_status_4`];
          const current_total_A_status_4_value = data['age_total_A_status_4'];
          const current_total_B_status_4_value = data['age_total_B_status_4'];
          const current_total_C_status_4_value = data['age_total_C_status_4'];

          if (item.key === 'status_0_percentage') {
            table_classified_data[table_key][item.key] = `${((current_A_status_0_value + current_B_status_0_value + current_C_status_0_value) / (current_total_A_status_0_value + current_total_B_status_0_value + current_total_C_status_0_value) * 100).toFixed(1)}%`
          } else if (item.key === 'status_1_percentage') {
            table_classified_data[table_key][item.key] = `${((current_A_status_1_value + current_B_status_1_value + current_C_status_1_value) / (current_total_A_status_1_value + current_total_B_status_1_value + current_total_C_status_1_value) * 100).toFixed(1)}%`
          } else if (item.key === 'status_2_percentage') {
            table_classified_data[table_key][item.key] = `${((current_A_status_2_value + current_B_status_2_value + current_C_status_2_value) / (current_total_A_status_2_value + current_total_B_status_2_value + current_total_C_status_2_value) * 100).toFixed(1)}%`
          } else if (item.key === 'status_3_percentage') {
            table_classified_data[table_key][item.key] = `${((current_A_status_3_value + current_B_status_3_value + current_C_status_3_value) / (current_total_A_status_3_value + current_total_B_status_3_value + current_total_C_status_3_value) * 100).toFixed(1)}%`
          } else if (item.key === 'status_4_percentage') {
            table_classified_data[table_key][item.key] = `${((current_A_status_4_value + current_B_status_4_value + current_C_status_4_value) / (current_total_A_status_4_value + current_total_B_status_4_value + current_total_C_status_4_value) * 100).toFixed(1)}%`
          } else if (item.key === 'all_percentage') {
            table_classified_data[table_key][item.key] = `${(table_classified_data[table_key].total_number / (current_total_A_status_0_value + current_total_B_status_0_value + current_total_C_status_0_value + current_total_A_status_1_value + current_total_B_status_1_value + current_total_C_status_1_value + current_total_A_status_2_value + current_total_B_status_2_value + current_total_C_status_2_value + current_total_A_status_3_value + current_total_B_status_3_value + current_total_C_status_3_value + current_total_A_status_4_value + current_total_B_status_4_value + current_total_C_status_4_value) * 100).toFixed(1)}%`
          } else if (item.key !== 'age' && item.key !== 'total_number') {
            table_classified_data[table_key][item.key] = {
              age: table_classified_data[table_key].age,
              age_start: table_classified_data[table_key].age_start,
              age_end: table_classified_data[table_key].age_end,
              plan: item.plan,
              status: item.status,
              value: data[current_key],
              isOpenContractModal: table_key !== 'age_total'
            };
            table_classified_data[table_key].total_number += data[current_key];
          }
        });
      })

      this.data.table_data = Object.values(table_classified_data);
    },
    // 開啟契約 modal
    openContractModal(item = null) {
      this.status.contractModal = true;
      this.data.temp_table_data = Object.assign({}, item);
    },
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/memberAgeDistribution.vue